import { render, staticRenderFns } from "./bankCharged.vue?vue&type=template&id=6143c220&"
import script from "./bankCharged.vue?vue&type=script&lang=js&"
export * from "./bankCharged.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports